import '@cc/ui/jetons.css';
import '@cc/ui/polices';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Application } from './Application';
import { appliquerPreferencesInitiales } from './preferences/FournisseurPreferences';

appliquerPreferencesInitiales();

const racine = document.getElementById('racine');
if (!racine) throw new Error('Élément #racine absent');
createRoot(racine).render(
  <StrictMode>
    <Application />
  </StrictMode>,
);
